import React from 'react';
import { ReactComponent as ReturnPercentage } from 'assets/icons/project-return-money-green.svg';
import { ReactComponent as Frequency } from 'assets/icons/certification-green.svg';
import { ReactComponent as Money } from 'assets/icons/project-money-green.svg';
import { ReactComponent as Time } from 'assets/icons/project-watch-money-green.svg';
import { ReactComponent as Document } from 'assets/icons/document-money-green.svg';
import { ReactComponent as BarGraph } from 'assets/icons/barGraph.svg';
import { formatNumber } from 'util/formatNumber';
import { colorByProjectType, issuanceTypes, typesProjectType } from 'types/projectType';
import { calculatePercentage } from 'util/percent';
import { useMediaQuery } from 'hooks';
import { Grid, Box } from '@material-ui/core';
import InfoCard, { InfoCardTemplate } from 'components/InfoCard';
import { colors } from 'globalStyle';
import { capitalizeFirstLetterString } from 'util/capitalizeFirstLetter';
import { payFrequency } from 'types';
import { Title, Text } from 'components/Texts';
import { routes } from 'routes';
import { Ghost } from 'components/Buttons';

export default function TokensConditions({
  numberNodes,
  nodePerPackage,
  issuanceType,
  growthProjectionPercentage,
  growthProjectionDescription,
  valuationDescription,
  nodeValue,
  maxAmount,
  projectType,
  annualValuationPercentage,
  ieaTax,
  projectId,
  id,
  currencyIso,
  resourcesGathering,
  valuation,
  frequency,
  percentageProvisions,
  adminTax,
  investmentTimeDescription,
  styles,
  color,
}) {
  const isDesktop = useMediaQuery(1023);
  const conditionsTokensProject = [
    {
      xs: isDesktop && 4,
      image: <ReturnPercentage color={color || colorByProjectType[projectType]} />,
      style: styles.primaryCard,
      title: `Recibe el ${ieaTax * 100}% E.A. aproximado`,
      subtitle: 'Retorno estimado',
      imageWidth: isDesktop ? '50px' : '30px',
      description: 'Es el porcentaje esperado que recibes en un año sobre tu inversión inicial. Este retorno es variable.',
    },
    {
      xs: isDesktop && 4,
      image: <BarGraph color={color || colorByProjectType[projectType]} />,
      style: styles.primaryCard,
      title: `${calculatePercentage(annualValuationPercentage)}%`,
      subtitle: 'Valorización anual estimada',
      imageWidth: isDesktop ? '45px' : '28px',
      description:
            'Posible incremento sobre el valor actual del activo en un año.',
    },
    {
      xs: isDesktop && 4,
      image: <ReturnPercentage color={color || colorByProjectType[projectType]} />,
      style: styles.primaryCard,
      title: `${
        issuanceType === issuanceTypes.INDIVIDUAL
          ? formatNumber(nodeValue, null, currencyIso)
          : formatNumber(nodeValue * nodePerPackage, null, currencyIso)
      }`,
      subtitle: `${
        issuanceType === issuanceTypes.INDIVIDUAL
          ? 'Precio por Token'
          : 'Valor mínimo de inversión'
      }`,
      imageWidth: isDesktop ? '50px' : '30px',
      description: `${
        issuanceType === issuanceTypes.INDIVIDUAL
          ? 'Corresponde al valor más pequeño que puedes comprar.'
          : 'Corresponde al grupo de Tokens más pequeño que puedes comprar.'
      }`,
    },
    {
      xs: isDesktop && 4,
      image: <Money color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: numberNodes,
      subtitle: 'Tokens de la ronda',
      imageWidth: isDesktop ? '50px' : '30px',
      description: 'Cantidad de Tokens que la empresa pone en venta',
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image: <Money color={color || colorByProjectType[projectType]} />,
      style: styles.primaryCard,
      title: formatNumber(maxAmount, null, currencyIso),
      subtitle: 'Monto a recaudar',
      imageWidth: isDesktop ? '45px' : '28px',
      description:
        'La cantidad total de dinero que se busca recaudar en la emisión de Tokens.',
    },
    {
      xs: isDesktop && 4,
      image: <Document color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: (
        <>
          <span style={{ textAlign: 'center' }}>{payFrequency[frequency]}</span>
          <br />

        </>
      ),
      moreInfo: 'Recuerda que al ser un retorno variable puede ser que no recibas pagos en todos los períodos.',
      subtitle: 'Período de pago de rendimientos:',
      imageWidth: isDesktop ? '45px' : '28px',
      description:
            'Indica la periodicidad de pago de rendimientos variables sobre la inversión realizada. (mensual, bimestral, trimestral, o semestral)',
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image: <Document color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: formatNumber(valuation, null, currencyIso),
      subtitle: 'Valoración de la empresa:',
      imageWidth: isDesktop ? '45px' : '28px',
      description: (
        <>
          {`${valuationDescription}`}
          <br />
          Este valor es proporcionado por la empresa, Bloom no tiene injerencia
          ni se hace responsible por este.
        </>
      ),
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image: <Frequency color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: `${calculatePercentage(growthProjectionPercentage)}%`,
      subtitle: 'Proyección de crecimiento',
      imageWidth: isDesktop ? '45px' : '28px',
      description: growthProjectionDescription,
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image:
        issuanceType === issuanceTypes.INDIVIDUAL ? (
          <Time color={color || colorByProjectType[projectType]} />
        ) : (
          <Money color={color || colorByProjectType[projectType]} />
        ),
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: (
        <>
          {issuanceType === issuanceTypes.INDIVIDUAL
            ? resourcesGathering
            : nodePerPackage}
        </>
      ),
      subtitle: `${
        issuanceType === issuanceTypes.INDIVIDUAL
          ? 'Recolección de recursos'
          : 'Número de Tokens por paquete'
      }`,
      imageWidth: isDesktop ? '50px' : '30px',
      description:
        issuanceType === issuanceTypes.INDIVIDUAL
          ? 'Tiempo durante el cual se planea hacer la recolección de los recursos para la financiación.'
          : 'Cantidad de Tokens que tiene cada uno de los paquetes mínimos de inversión',
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image: <Frequency color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: `${calculatePercentage(percentageProvisions)}%`,
      subtitle: 'Provisiones',
      imageWidth: isDesktop ? '45px' : '28px',
      description:
            'Porcentaje periódico resguardado para solventar imprevistos y obligaciones tributarias',
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image: <Frequency color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: `${calculatePercentage(adminTax)}%`,
      subtitle: 'Cuota de administración',
      imageWidth: isDesktop ? '45px' : '28px',
      description:
            'Porcentaje cobrado por el administrador del activo sobre el retorno periodico.',
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image: <Time color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: 'Indefinido',
      subtitle: `${capitalizeFirstLetterString(investmentTimeDescription)}`,
      imageWidth: isDesktop ? '50px' : '30px',
      description: 'El período de tiempo previsto donde el proyecto genera rentabilidad',
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
  ];

  if (!isDesktop) {
    return (
      <Grid container spacing={isDesktop && 2} className={styles.root}>
        {conditionsTokensProject?.map(
          ({
            xs,
            image,
            style,
            title,
            subtitle,
            imageWidth,
            isBigTitle,
            description,
            hoverDescription,
          }) => (
            <Grid item xs={xs}>
              <InfoCard
                isDesktop={isDesktop}
                image={image}
                className={style}
                color={colors.GRAY_10}
                title={title}
                subtitle={subtitle}
                imageWidth={imageWidth}
                description={description}
                fullDescription
                centerDescription
                isBigTitle={isBigTitle}
                hoverDescription={hoverDescription && isDesktop}
                colorByProjectType={color || colorByProjectType[projectType]}
              />
            </Grid>
          ),
        )}
        <Grid item xs={isDesktop && 4}>
          <InfoCardTemplate className={styles.primaryCard}>
            <Grid
              container
              justify="space-evenly"
              direction="column"
              alignItems="center"
              style={{ height: '100%' }}
            >
              <Box width="45px">
                <Time color={color || colorByProjectType[projectType]} />
              </Box>
              <Text size={12} isCenter>
                Tipo de proyecto:
              </Text>
              <Title size={12} isCenter>
                {typesProjectType[projectType]}
              </Title>
              <Ghost
                underline
                size={12}
                color={colors.primary}
                href={`${routes.conditionsAndCharacteristics.route}/${projectType.toLowerCase()}/${id || projectId}`}
              >
                Conoce más
              </Ghost>
            </Grid>
          </InfoCardTemplate>
        </Grid>

      </Grid>
    );
  }
  return (
    <Grid container spacing={isDesktop && 2} className={styles.root}>
      {conditionsTokensProject?.map(
        ({
          xs,
          image,
          style,
          title,
          subtitle,
          imageWidth,
          description,
          hoverDescription,
          moreInfo,
        }) => (
          <Grid item xs={xs}>
            <InfoCard
              isDesktop={isDesktop}
              image={image}
              className={style}
              color={colors.GRAY_10}
              title={title}
              subtitle={subtitle}
              imageWidth={imageWidth}
              description={description}
              fullDescription
              centerDescription
              hoverDescription={hoverDescription && isDesktop}
              colorByProjectType={color || colorByProjectType[projectType]}
              moreInfo={moreInfo}
            />
          </Grid>
        ),
      )}
    </Grid>
  );
}
